const BASE = '/api'

export const getSessionId  = ()  => localStorage.getItem('session_id')
export const saveSessionId = (id) => localStorage.setItem('session_id', id)
export const clearSessionId = () => localStorage.removeItem('session_id')

export async function request(path, options = {}) {
  const sid = getSessionId()
  const headers = {
    'Content-Type': 'application/json',
    ...(sid ? { Authorization: `Bearer ${sid}` } : {}),
    ...(options.headers || {}),
  }
  let res
  try {
    res = await fetch(BASE + path, { ...options, headers })
  } catch (err) {
    throw new ApiError('NETWORK_ERROR', err.message, 0)
  }
  const json = await res.json().catch(() => { throw new ApiError('PARSE_ERROR', 'Invalid JSON', res.status) })
  if (!json.ok) {
    const { code, message } = json.error || {}
    if (code === 'SESSION_EXPIRED' || code === 'SESSION_MISSING') {
      clearSessionId()
      window.dispatchEvent(new CustomEvent('session:expired'))
    }
    throw new ApiError(code || 'UNKNOWN', message || 'Error', res.status)
  }
  return json.data
}

export const get  = (path, q)    => request(path + toQuery(q))
export const post = (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) })
export const del  = (path)       => request(path, { method: 'DELETE' })

function toQuery(p) {
  if (!p) return ''
  const qs = Object.entries(p).filter(([,v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
  return qs ? `?${qs}` : ''
}

export class ApiError extends Error {
  constructor(code, message, status) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
  }
}
